import { ProgressBar } from "react-bootstrap";

function Loader() {
  return <ProgressBar animated now={100} variant="info" />;
}

export default Loader;
